<template>
  <div class="d-flex align-items-center">
    <i class="mr-2" :class="option.icon" v-if="option.icon"></i>
    {{ option.label }}
  </div>
</template>

<script>
/**
 * This provides the template for the individual items in Status filter dropdown
 */
export default {
  name: 'StatusListItemTemplate',
  props: ['option']
}
</script>
